import React from 'react';
import { Row, Col } from 'antd';
import bankLogo from 'images/bank_logo.svg';

interface BankProps {
    bankInfo: any;
}

const BankDetails: React.FC<BankProps> = ({ bankInfo }: BankProps) => {
    return <div>
        {bankInfo &&
            <div>
                <Row gutter={32}>
                    <Col xs={3} md={2}>
                        <img src={bankLogo} alt="bank logo" />
                    </Col>
                    <Col xs={18}>
                        <p className='bankName'>{bankInfo?.bankName?.toLowerCase()} </p>
                        <p>Acc. No. {bankInfo?.bankAccountNumber}</p>
                    </Col>
                </Row>

            </div>
        }
    </div>;
}

export default BankDetails;